import React from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaPhone, FaHome } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Bolanir</h3>
            <p>
              Il tuo blog dedicato alla letteratura, libri curati e cancelleria
              di qualita. Esplora il mondo delle parole con noi.
            </p>
          </div>
          <div className="footer-section">
            <h3>Link Rapidi</h3>
            <Link to="/">Home</Link>
            <Link to="/about">Chi Siamo</Link>
            <Link to="/contact">Contatti</Link>
          </div>
          <div className="footer-section">
            <h3>Contatti</h3>
            <p>
              <FaHome /> Piazza Luigi Ceriana, 15121 Alessandria AL
              <br />
              Italia
            </p>
            <p>
              <FaPhone /> +393923212000
            </p>
            <p>
              Email:{" "}
              <a href="mailto:bolanir@hotmail.com">bolanir@hotmail.com</a>
            </p>
            <p>
              <a href="https://wa.me/393923212000">WhatsApp</a>
            </p>
            <p>
              <a href="https://viber.me/393923212000">Viber</a>
            </p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>P.IVA: 83022762 - Tutti i diritti riservati Bolanir 2026</p>
          <div className="footer-links">
            <Link to="/privacy-policy">Politica sulla Privacy</Link>
            <Link to="/terms-conditions">Termini e Condizioni</Link>
            <Link to="/refund-policy">Politica di Rimborso</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
